import { put } from 'epics/ajax';
import { contextPath } from 'util/history';
import { Observable } from 'epics/rxjs';

export interface RequestGroupReorderRequest {
    id: string;
    deleted: number[];
    order: number[];
    inline: boolean;
    projectId: number;
}

export interface RequestGroup {
    id: number;
    name: string;
}

// TODO use common error shape from src/util/errors/errors.tsx
export interface RequestGroupError {
    errors: { errorMessage: string }[];
    reasonKey: string;
    reasonCode: string;
}

export interface RequestGroupResponse {
    reordered: RequestGroup[];
    deleted: RequestGroup[];
    deletedTime: number;
}

export const requestGroupReorder = ({
    id,
    deleted,
    order,
    inline,
    projectId,
}: RequestGroupReorderRequest): Observable<RequestGroupResponse> => {
    const uri = `${contextPath}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;

    const body = { id, deleted, order, inline };

    return put(uri, body, { 'Content-Type': 'application/json' })
        .map(({ response }) => response as RequestGroupResponse)
        .catch((e) => {
            return Observable.throw(e);
        });
};
